import { Text } from '@modusign/design-system';
import { ReactNode } from 'react';

interface TabButtonProps {
  children: ReactNode;
  active: boolean;
  onClick: () => void;
}

export default function TabButton({ active, children, onClick }: TabButtonProps) {
  return (
    <Text
      aria-selected={active}
      as="button"
      py={3}
      role="tab"
      sx={
        active
          ? {
              color: 'textNeutralBase',
              fontWeight: 'medium',
              flex: 1,
              borderRadius: '6px',
              boxShadow: '0px 3px 2px -2px rgba(0, 0, 0, 0.06)',
              bg: 'buttonBackgroundNeutralLightest',
            }
          : {
              color: 'textNeutralVeryLight',
              cursor: 'pointer',
              fontWeight: 'regular',
              flex: 1,
              borderRadius: '6px',
              '&:hover': {
                bg: 'buttonBackgroundNeutralBase',
              },
            }
      }
      type="button"
      onClick={onClick}
    >
      {children}
    </Text>
  );
}
